import { icons } from "assets/AssetHelper";
import dayjs from "dayjs";

export const detailsData = (t, { data }) => [
  {
    head: t("gift_cards.details"),
    icon: icons?.details,
    details: [
      {
        label: "Zone name(EN)",
        name: data?.localized_data?.en?.name,
      },
      {
        label: "Zone name(AR)",
        name: data?.localized_data?.ar?.name,
      },
      {
        label: t("common.city"),
        name: data?.google_city?.name,
      },
    ],
  },
  {
    head: t("cities.fees"),
    icon: icons?.fees,
    details: [
      {
        label: t("zones.delivery_fees"),
        name: `${data?.delivery_fees} SAR`,
      },
    ],
  },
  {
    head: t("cities.map_details"),
    icon: icons?.map,
    details: [
      {
        label: t("cities.lat"),
        name: data?.lat,
        width: "30%",
      },
      {
        label: t("cities.long"),
        name: data?.long,
        width: "30%",
      },
      {
        label: t("zones.radius"),
        name: `${data?.radius} KM`,
        width: "30%",
      },
    ],
  },
  {
    head: t("gift_cards.dates"),
    icon: icons?.dates,
    details: [
      {
        label: t("gift_cards.created_at"),
        name: dayjs(data?.created_at).format("DD-MM-YYYY HH:MM a"),
      },
      {
        label: t("gift_cards.updated_at"),
        name: dayjs(data?.updated_at).format("DD-MM-YYYY HH:MM a"),
      },
    ],
  },
];
